export const bannertableColumns = [
  {
    id: "bookings.banner",
    label: "Image",
    minWidth: 70,
    align: "left",
    type: "IMAGE",
  },
  {
    id: "createdAt",
    label: "Created At",
    minWidth: 70,
    align: "center",
  },
  {
    id: "startDate",
    label: "Start Date",
    minWidth: 70,
    align: "center",
  },
  {
    id: "endDate",
    label: "End Date",
    minWidth: 70,
    align: "center",
  },
  {
    id: "vendorData.fullName",
    label: "Vendor",
    minWidth: 70,
    align: "center",
  },
  {
    id: "vendorData.email",
    label: "Vendors Email",
    minWidth: 70,
    align: "center",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 70,
    align: "center",
  },
];
